import { useSEO } from '../../../utils/seo';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';

interface Course {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  instructor: string;
  duration: string;
  lessons: number;
  level: 'Beginner' | 'Intermediate' | 'Advanced';
  category: string;
  price: number;
  rating: number;
  students: number;
  enrolled: boolean;
}

export default function CourseCatalog() {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedLevel, setSelectedLevel] = useState<string>('all');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const courses: Course[] = [
    {
      id: '1',
      title: 'BigData Analytics Fundamentals',
      description: 'Master the fundamentals of BigData processing, analysis, and visualization. Learn to work with large-scale datasets using modern tools and frameworks.',
      thumbnail: 'https://public.readdy.ai/ai/img_res/6d5541cae9f55e5632e555239b9c30c6.jpg',
      instructor: 'Dr. Sarah Chen',
      duration: '8 hours',
      lessons: 24,
      level: 'Intermediate',
      category: 'BigData',
      price: 199,
      rating: 4.8,
      students: 1250,
      enrolled: false
    },
    {
      id: '2',
      title: 'DevOps CI/CD Pipeline Mastery',
      description: 'Build, deploy, and manage automated CI/CD pipelines. Learn industry best practices for continuous integration and deployment.',
      thumbnail: 'https://readdy.ai/api/search-image?query=devops%20continuous%20integration%20pipeline%20visualization%20with%20connected%20nodes%20and%20automation%20symbols%20on%20dark%20teal%20background%20modern%20tech%20illustration%20clean%20professional%20style&width=800&height=450&seq=catalog-course-2&orientation=landscape',
      instructor: 'Michael Rodriguez',
      duration: '6 hours',
      lessons: 18,
      level: 'Advanced',
      category: 'DevOps',
      price: 249,
      rating: 4.9,
      students: 980,
      enrolled: false
    },
    {
      id: '3',
      title: 'Cybersecurity Threat Detection',
      description: 'Learn advanced techniques for identifying, analyzing, and mitigating cybersecurity threats. Protect systems from modern attacks.',
      thumbnail: 'https://readdy.ai/api/search-image?query=cybersecurity%20shield%20with%20digital%20lock%20and%20network%20protection%20symbols%20on%20dark%20red%20background%20modern%20security%20concept%20professional%20illustration%20clean%20design&width=800&height=450&seq=catalog-course-3&orientation=landscape',
      instructor: 'Emily Watson',
      duration: '7 hours',
      lessons: 20,
      level: 'Advanced',
      category: 'Cybersecurity',
      price: 299,
      rating: 4.9,
      students: 1450,
      enrolled: false
    },
    {
      id: '4',
      title: 'Cryptocurrency & Blockchain Basics',
      description: 'Understand blockchain technology, cryptocurrency fundamentals, and smart contract development from the ground up.',
      thumbnail: 'https://readdy.ai/api/search-image?query=cryptocurrency%20blockchain%20network%20with%20golden%20bitcoin%20symbols%20and%20connected%20blocks%20on%20dark%20orange%20background%20modern%20crypto%20illustration%20professional%20clean%20style&width=800&height=450&seq=catalog-course-4&orientation=landscape',
      instructor: 'James Liu',
      duration: '5 hours',
      lessons: 15,
      level: 'Beginner',
      category: 'Crypto',
      price: 149,
      rating: 4.7,
      students: 2100,
      enrolled: false
    },
    {
      id: '5',
      title: 'Cloud Infrastructure Management',
      description: 'Master cloud computing platforms, resource optimization, and infrastructure as code. Deploy scalable applications in the cloud.',
      thumbnail: 'https://readdy.ai/api/search-image?query=cloud%20computing%20infrastructure%20with%20servers%20and%20network%20connections%20on%20dark%20purple%20background%20modern%20technology%20illustration%20professional%20clean%20design&width=800&height=450&seq=catalog-course-5&orientation=landscape',
      instructor: 'David Park',
      duration: '9 hours',
      lessons: 28,
      level: 'Intermediate',
      category: 'Cloud',
      price: 279,
      rating: 4.8,
      students: 1680,
      enrolled: false
    },
    {
      id: '6',
      title: 'Web3 & DeFi Development',
      description: 'Build decentralized applications, integrate Web3 wallets, and create DeFi protocols. Learn the future of web development.',
      thumbnail: 'https://readdy.ai/api/search-image?query=web3%20decentralized%20network%20with%20blockchain%20nodes%20and%20cryptocurrency%20symbols%20on%20dark%20pink%20background%20modern%20digital%20illustration%20professional%20style&width=800&height=450&seq=catalog-course-6&orientation=landscape',
      instructor: 'Alexandra Kim',
      duration: '10 hours',
      lessons: 32,
      level: 'Advanced',
      category: 'Web3',
      price: 349,
      rating: 4.9,
      students: 890,
      enrolled: false
    },
    {
      id: '7',
      title: 'Monitoring & Observability',
      description: 'Implement comprehensive monitoring solutions, create dashboards, and set up intelligent alerting systems for production environments.',
      thumbnail: 'https://readdy.ai/api/search-image?query=monitoring%20dashboard%20with%20real%20time%20metrics%20and%20graphs%20on%20dark%20indigo%20background%20modern%20analytics%20visualization%20professional%20clean%20design&width=800&height=450&seq=catalog-course-7&orientation=landscape',
      instructor: 'Robert Chen',
      duration: '6 hours',
      lessons: 19,
      level: 'Intermediate',
      category: 'Observability',
      price: 199,
      rating: 4.7,
      students: 1120,
      enrolled: false
    },
    {
      id: '8',
      title: 'Machine Learning for Data Scientists',
      description: 'Apply machine learning algorithms to real-world problems. Learn supervised and unsupervised learning techniques.',
      thumbnail: 'https://readdy.ai/api/search-image?query=machine%20learning%20neural%20network%20with%20data%20nodes%20and%20connections%20on%20dark%20green%20background%20modern%20ai%20illustration%20professional%20clean%20style&width=800&height=450&seq=catalog-course-8&orientation=landscape',
      instructor: 'Dr. Maria Santos',
      duration: '12 hours',
      lessons: 36,
      level: 'Advanced',
      category: 'BigData',
      price: 399,
      rating: 4.9,
      students: 1890,
      enrolled: false
    }
  ];

  const categories = ['all', 'BigData', 'DevOps', 'Cybersecurity', 'Crypto', 'Cloud', 'Web3', 'Observability'];
  const levels = ['all', 'Beginner', 'Intermediate', 'Advanced'];

  const filteredCourses = courses.filter(course => {
    const matchesCategory = selectedCategory === 'all' || course.category === selectedCategory;
    const matchesLevel = selectedLevel === 'all' || course.level === selectedLevel;
    const matchesSearch = course.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         course.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesLevel && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gray-950">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Course Catalog
            </h1>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Explore our comprehensive collection of professional training courses
            </p>
          </div>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto mb-8">
            <div className="relative">
              <input
                type="text"
                placeholder="Search courses..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-6 py-4 bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-teal-500 text-base"
              />
              <i className="ri-search-line absolute right-6 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
            </div>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap gap-4 justify-center">
            {/* Category Filter */}
            <div className="flex gap-2">
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-teal-500 text-gray-900'
                      : 'bg-gray-800/50 text-gray-400 hover:bg-gray-800 hover:text-gray-300'
                  }`}
                >
                  {category === 'all' ? 'All Categories' : category}
                </button>
              ))}
            </div>

            {/* Level Filter */}
            <div className="flex gap-2">
              {levels.map(level => (
                <button
                  key={level}
                  onClick={() => setSelectedLevel(level)}
                  className={`px-4 py-2 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap ${
                    selectedLevel === level
                      ? 'bg-cyan-500 text-gray-900'
                      : 'bg-gray-800/50 text-gray-400 hover:bg-gray-800 hover:text-gray-300'
                  }`}
                >
                  {level === 'all' ? 'All Levels' : level}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Courses Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between mb-8">
            <p className="text-gray-400">
              Showing <span className="text-white font-semibold">{filteredCourses.length}</span> courses
            </p>
            <Link
              to="/lms/student-dashboard"
              className="text-teal-400 hover:text-teal-300 transition-colors cursor-pointer"
            >
              <i className="ri-dashboard-line mr-2"></i>
              My Dashboard
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCourses.map((course) => (
              <div
                key={course.id}
                className="bg-gray-800/50 backdrop-blur-sm rounded-xl overflow-hidden border border-gray-700 hover:border-teal-500/50 transition-all group"
              >
                {/* Thumbnail */}
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={course.thumbnail}
                    alt={course.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4 px-3 py-1 bg-gray-900/90 backdrop-blur-sm rounded-full text-xs text-white">
                    {course.level}
                  </div>
                  <div className="absolute top-4 right-4 px-3 py-1 bg-teal-500 rounded-full text-xs text-gray-900 font-semibold">
                    ${course.price}
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs text-gray-400 mb-2">
                    <span className="px-2 py-1 bg-gray-700 rounded">{course.category}</span>
                  </div>

                  <h3 className="text-xl font-bold text-white mb-2 group-hover:text-teal-400 transition-colors">
                    {course.title}
                  </h3>
                  
                  <p className="text-gray-400 text-sm mb-4 line-clamp-2">
                    {course.description}
                  </p>

                  <div className="flex items-center gap-2 text-sm text-gray-400 mb-4">
                    <i className="ri-user-line"></i>
                    <span>{course.instructor}</span>
                  </div>

                  {/* Stats */}
                  <div className="flex items-center justify-between text-sm text-gray-400 mb-4 pb-4 border-b border-gray-700">
                    <div className="flex items-center gap-1">
                      <i className="ri-play-circle-line"></i>
                      <span>{course.lessons} lessons</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      <span>{course.duration}</span>
                    </div>
                  </div>

                  {/* Rating & Students */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-amber-400"></i>
                      <span className="text-white font-semibold">{course.rating}</span>
                      <span className="text-gray-400 text-sm">({course.students})</span>
                    </div>
                  </div>

                  {/* Action Button */}
                  {course.enrolled ? (
                    <Link
                      to={`/lms/course/${course.id}`}
                      className="block w-full px-4 py-2 bg-teal-500 text-gray-900 rounded-lg font-semibold hover:bg-teal-400 transition-all cursor-pointer whitespace-nowrap text-center"
                    >
                      Continue Learning
                    </Link>
                  ) : (
                    <button className="w-full px-4 py-2 bg-gray-700 text-white rounded-lg font-semibold hover:bg-gray-600 transition-all cursor-pointer whitespace-nowrap">
                      Enroll Now
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          {filteredCourses.length === 0 && (
            <div className="text-center py-20">
              <div className="w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-search-line text-4xl text-gray-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">No courses found</h3>
              <p className="text-gray-400 mb-6">
                Try adjusting your filters or search query
              </p>
              <button
                onClick={() => {
                  setSelectedCategory('all');
                  setSelectedLevel('all');
                  setSearchQuery('');
                }}
                className="px-6 py-3 bg-teal-500 text-gray-900 rounded-lg font-semibold hover:bg-teal-400 transition-all cursor-pointer whitespace-nowrap"
              >
                Clear Filters
              </button>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
